import React, { FC } from 'react';
import { LazyLoad } from '../LazyLoad';
import { declineNumeric, formatPrice } from '../../utils/format_helper';
import { waitForImage } from '../../../shared/utils/lazy_load_helper';
import styles from './PopularItem.css';
import { LinkArea } from '../LinkArea';

interface IProps {
  metro?: {
    timeType: string;
    name: string;
    lineColor: string;
    time: number;
  };
  title: string;
  url: string;
  priceAmount: number;
  price: {
    amount: number;
    priceType?: string;
  };
  address?: string;
  thumbnailUrl: string;
}

export const PopularItem: FC<IProps> = ({ url, thumbnailUrl, price, title, metro, address }) => {
  return (
    <LinkArea href={url} className={styles['popular-block']}>
      <LazyLoad
        onLoad={() => waitForImage(thumbnailUrl)}
        renderEmpty={() => <div className={styles['popular-photo-wrap']} />}
        renderLoaded={() => (
          <div
            className={styles['popular-photo-wrap']}
            style={{
              backgroundImage: `url(${thumbnailUrl})`,
            }}
          />
        )}
      />
      <div className={styles['popular-info']}>
        <span className={styles['popular-price']}>
          {formatPrice(price.amount, 4)}
          <span> ₽</span>
        </span>
        {/* eslint-disable-next-line react/no-danger */}
        <a
          href={url}
          className={styles['popular-tec-info']}
          // eslint-disable-next-line react/no-danger
          dangerouslySetInnerHTML={{ __html: title }}
        />
        {metro ? (
          <div className={styles['popular-metro']}>
            <span className={styles['popular-metro-name']}>
              <span
                className={styles['line-marker']}
                style={{
                  backgroundColor: `#${metro.lineColor}`,
                }}
              />
              {metro.name}
            </span>
            {metro.time !== null && (
              <span className={styles['popular-metro-time']}>
                {metro.time}
                &nbsp;
                {declineNumeric(metro.time, ['минута', 'минуты', 'минут'])}
                &nbsp; пешком
              </span>
            )}
          </div>
        ) : (
          <div className={styles['popular-address']}>{address}</div>
        )}
      </div>
    </LinkArea>
  );
};
